import React from 'react'
import { observer } from 'mobx-react'
import { FavoriteIco } from '@shared/Icon/MatchupIcon'
import { FavoriteBtn } from '@components/Button/FavoriteUsersButton/index.style'
// import FavoriteImg from '@assets/images/btn/favorite-manage.png'
import FavoriteActiveImg from '@assets/images/btn/favorite-manage-mono-active.png'
import FavoriteImgGray from '@assets/images/btn/favorite-manage-gray.png'

interface FavoriteUsersButtonProps {
  className?: string
  onClick?: (e: React.MouseEvent<HTMLElement>) => void
}

export const FavoriteUsersButton: React.FC<FavoriteUsersButtonProps> = observer((props) => {
  const { className, onClick } = props

  // const FavoriteBtnImg = <img src={FavoriteImg} className='favorite-btn-img' alt='favorite-btn'/>
  const FavoriteBtnGrayImg = <img src={FavoriteImgGray} className="favorite-btn-img" alt="favorite-btn"/>
  const FavoriteActiveBtnImg = <img src={FavoriteActiveImg} className='favorite-btn-active-img' alt='favorite-btn-active'/>

  return (
    <FavoriteBtn className={className} onClick={onClick}>
      <span className="favorite-pulse"/>
      <span className="favorite-pulse pulse-2"/>
      {FavoriteBtnGrayImg}
      {FavoriteActiveBtnImg}
      <FavoriteIco/>
    </FavoriteBtn>
  )
})